import Vue from 'vue';



//helper app
import './Components/Helpers/HelperComponent';

/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
/*Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);
*/
// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);


//Slider Components
Vue.component('slider-list', require('./Components/Views/Auth/Slider/SliderList').default);
Vue.component('slider-add', require('./Components/Views/Auth/Slider/SliderAdd').default);
Vue.component('slider-edit', require('./Components/Views/Auth/Slider/SliderEdit').default);

//Gallery Components
Vue.component('gallery-list', require('./Components/Views/Auth/Gallery/GalleryList').default);
Vue.component('gallery-add', require('./Components/Views/Auth/Gallery/GalleryAdd').default);
Vue.component('gallery-edit', require('./Components/Views/Auth/Gallery/GalleryEdit').default);

//CMS Components
Vue.component('cms-list', require('./Components/Views/Auth/Cms/CmsList').default);
Vue.component('cms-add', require('./Components/Views/Auth/Cms/CmsAdd').default);
Vue.component('cms-edit', require('./Components/Views/Auth/Cms/CmsEdit').default);
Vue.component('cms-view', require('./Components/Views/Auth/Cms/CmsView').default);

//Offices Component
Vue.component('office-list', require('./Components/Views/Auth/Office/OfficeList').default);
Vue.component('office-add', require('./Components/Views/Auth/Office/OfficeAdd').default);
Vue.component('office-edit', require('./Components/Views/Auth/Office/OfficeEdit').default);

//Our Team Component
Vue.component('team-list', require('./Components/Views/Auth/OurTeam/TeamList').default);
Vue.component('team-add', require('./Components/Views/Auth/OurTeam/TeamAdd').default);
Vue.component('team-edit', require('./Components/Views/Auth/OurTeam/TeamEdit').default);

//Blog Category Component
Vue.component('blog-category-list', require('./Components/Views/Auth/Blog/Category/BlogCategoryList').default);
Vue.component('blog-category-add', require('./Components/Views/Auth/Blog/Category/BlogCategoryAdd').default);
Vue.component('blog-category-edit', require('./Components/Views/Auth/Blog/Category/BlogCategoryEdit').default);


//Blog Category Component
Vue.component('blog-list', require('./Components/Views/Auth/Blog/BlogList').default);
Vue.component('blog-add', require('./Components/Views/Auth/Blog/BlogAdd').default);
Vue.component('blog-edit', require('./Components/Views/Auth/Blog/BlogEdit').default);

//Service Category Component
Vue.component('service-category-list', require('./Components/Views/Auth/Service/Category/ServiceCategoryList').default);
Vue.component('service-category-add', require('./Components/Views/Auth/Service/Category/ServiceCategoryAdd').default);
Vue.component('service-category-edit', require('./Components/Views/Auth/Service/Category/ServiceCategoryEdit').default);


//Service Category Component
Vue.component('service-list', require('./Components/Views/Auth/Service/ServiceList').default);
Vue.component('service-add', require('./Components/Views/Auth/Service/ServiceAdd').default);
Vue.component('service-edit', require('./Components/Views/Auth/Service/ServiceEdit').default);

//Service Category Component
Vue.component('contact-list', require('./Components/Views/Auth/Contact/ContactList').default);
Vue.component('contact-add', require('./Components/Views/Auth/Contact/ContactAdd').default);
Vue.component('contact-edit', require('./Components/Views/Auth/Contact/ContactEdit').default);

//Widget Component
Vue.component('widget-list', require('./Components/Views/Auth/Widget/WidgetList').default);
Vue.component('widget-add', require('./Components/Views/Auth/Widget/WidgetAdd').default);
Vue.component('widget-edit', require('./Components/Views/Auth/Widget/WidgetEdit').default);